import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BiLogo from "../IconsPack/BiLogo";
import DashboardIcon from '../../assets/icons/Dashboard.svg';
import ApplicationIcon from '../../assets/icons/Application.svg';
import PaymentIcon from '../../assets/icons/Payment.svg';
import PlacementIcon from '../../assets/icons/Placement.svg';
import MentorshipIcon from '../../assets/icons/Mentorship.svg';
import CareerIcon from '../../assets/icons/Career.svg';
import SupportIcon from '../../assets/icons/Support.svg';
import SignOutIcon from '../../assets/icons/SignOut.svg';
import { useAuthStore } from "../../features/auth/useAuthStore";
interface Props{
  onNavItemClicked: (item:string) => void;
}
const SideNav: React.FC<Props> = ({onNavItemClicked}) => {
  const navigate = useNavigate();
  const [selectedNavItem, setSelectedNavItem] = useState(0);
  const logout = useAuthStore.getState().logout;

  const navItems = [
    {
      label: "Dashboard",
      icon: DashboardIcon,
      route: "/dashboard",
    },
    {
      label: "Application",
      icon: ApplicationIcon,
      route: "/application",
    },
    {
      label: "Repayment",
      icon: PaymentIcon,
      route: "/repayment",
    },
    {
      label: "Placement",
      icon: PlacementIcon,
      route: "/",
    },
    {
      label: "Mentorship",
      icon: MentorshipIcon,
      route: "/",
    },
    {
      label: "Career",
      icon: CareerIcon,
      route: "/",
    },
    {
      label: "Support",
      icon: SupportIcon,
      route: "/support",
    },
    {
      label: "Sign Out",
      icon: SignOutIcon,
      route: "/auth/signin",
    },
  ];

  const handleNavItemClick = (item: any,index:number) => {
    if(item.label === 'Sign Out'){
      logout();
      navigate(item.route);
    }
    else{
      setSelectedNavItem(index);
      onNavItemClicked(item.label);
      navigate(item.route);

    }
  };

  return (
    <div className="w-full bg-white text-black flex flex-col items-center h-full">
      <div className="h-[50px] w-full flex items-center mt-3"><BiLogo /></div>
      <div className="w-full flex justify-center">
        <nav
          className="w-full mt-[60px] overflow-y-auto"
          style={{ maxHeight: "calc(100vh - 125px)" }}
        >
          {navItems.map((item, index) => (
            <React.Fragment key={index}>
              <div
                className={`flex items-left mb-4 py-[10px] px-10  rounded-[30px] cursor-pointer transition-colors duration-300 justify-left ${
                  selectedNavItem === index
                    ? "bg-primary rounded-br-[12px] rounded-tr-[0px] rounded-l-[0px] p-2"
                    : "hover:bg-gray-100 rounded-[3px] p-2"
                }`}
                onClick={() => handleNavItemClick(item,index)}
              >
                <div
                  className={`flex items-left text-black fill-current`}
                >
                  {<div className="w-[24px] h-[24px]"><img src={item.icon} width={'100%'} height={'100%'} /></div>}
                  <span className="ml-4 font-ubuntu text-[16px] text-center font-[400]">
                    {item.label}
                  </span>
                </div>
              </div>
              {index === 5 && (
                <div className="w-full h-[1px] px-[60px] bg-gray-300 my-4" />
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default SideNav;
